import React, { useState, useEffect } from "react";


import {
    Row, Col
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";


import {
    FormFieldStatusComponent, FormFieldStatusInterface
} from "@Elements/Forms";


import IconDropdownDownSmGrey from "./@Icons/icon-dropdown_down-sm-grey.svg";
import IconDropdownUpSmDarkGrey from "./@Icons/icon-dropdown_up-sm-dark_grey.svg";


import "./index.scss";


export interface DropdownFieldOptionInterface {
    optionId: number | string;
    optionText: string;
    optionIconLeft?: string;
    optionIconRight?: string;
}


interface DropdownFieldComponentProps {
    dropdownFieldLabel?: string;
    dropdownFieldOptions: DropdownFieldOptionInterface[];
    dropdownFieldOptionSelected: number | string;
    dropdownFieldOnChangeCallback?: (optionId: number | string) => void;
    dropdownFieldRequiredStatus?: boolean;
    dropdownFieldDisabledStatus?: boolean;
    dropdownFieldStatus?: FormFieldStatusInterface | null;
}


export const DropdownFieldComponent:React.FC<DropdownFieldComponentProps> = ({
    dropdownFieldLabel,
    dropdownFieldOptions, dropdownFieldOptionSelected,
    dropdownFieldOnChangeCallback,
    dropdownFieldRequiredStatus = false, dropdownFieldDisabledStatus = false,
    dropdownFieldStatus = null
}) => {


    const [dropdownOpenStatus, setDropdownOpenStatus] = useState(false);

    useEffect(() => {
        return () => {
            setDropdownOpenStatus(false);
        };
    }, []);


    const dropdownChangeOptionHandler = (optionId: number | string) => {
        if (dropdownFieldOnChangeCallback) {
            dropdownFieldOnChangeCallback(optionId);
        }
        setDropdownOpenStatus(false);
    };


    const dropdownSelectedOption = dropdownFieldOptions.filter(
        (dropdownOption) => dropdownOption.optionId === dropdownFieldOptionSelected
    )[0];


    const dropdownOptionsList = dropdownFieldOptions.map((dropdownOption) => {

        const {
            optionId, optionText,
            optionIconLeft, optionIconRight
        } = dropdownOption;

        if (optionId === dropdownFieldOptionSelected) {
            return null;
        }

        return (
            <Col key={optionId} xs={12} className={'dropdown-field-component__options-list__field-option'} onClick={() => dropdownChangeOptionHandler(optionId)}>
                <Row className={'dropdown-field-component__options-list__field-option__option-content'}>
                    {optionIconLeft &&
                    <Col xs={'auto'} className={'dropdown-field-component__options-list__field-option__option-icon dropdown-field-component__options-list__field-option__option-icon--left-icon'}>
                        <SvgIconComponent iconSource={optionIconLeft} />
                    </Col>
                    }
                    <Col xs={'auto'} className={'dropdown-field-component__options-list__field-option__option-text'}>
                        <span>{optionText}</span>
                    </Col>
                    {optionIconRight &&
                    <Col xs={'auto'} className={'dropdown-field-component__options-list__field-option__option-icon dropdown-field-component__options-list__field-option__option-icon--right-icon'}>
                        <SvgIconComponent iconSource={optionIconRight} />
                    </Col>
                    }
                </Row>
            </Col>
        );

    });


    return (
        <Col xs={12} className={`dropdown-field-component dropdown-field-${dropdownOpenStatus ? 'open' : 'closed'}`}>

            {dropdownFieldLabel &&
            <Col xs={12} className={'dropdown-field-component__field-label'}>
                <span className={'dropdown-field-component__field-label__label-text'}>{dropdownFieldLabel}</span>
                {dropdownFieldRequiredStatus && <span className={'dropdown-field-component__field-label__label-required-status'}>*</span>}
            </Col>
            }

            <Col xs={12} className={'dropdown-field-component__field-option dropdown-field-component__field-option--selected-option dropdown-field-component__field-option--dropdown-open'} onClick={() =>setDropdownOpenStatus(!dropdownOpenStatus)}>
                <span className={'dropdown-field-component__field-option__option-value'}>{dropdownSelectedOption?.optionText || ''}</span>
                <SvgIconComponent iconSource={dropdownOpenStatus ? IconDropdownUpSmDarkGrey : IconDropdownDownSmGrey} className={'dropdown-field-component__field-option__dropdown-icon'} />
            </Col>

            {dropdownOpenStatus &&
            <Col xs={12} className={'dropdown-field-component__options-list'}>
                <Row className={'dropdown-field-component__options-list__list-content'}>
                    {dropdownOptionsList}
                </Row>
            </Col>
            }

            {dropdownFieldStatus &&
            <FormFieldStatusComponent formFieldStatus={dropdownFieldStatus} />
            }

            </Col>
    );

};


export default DropdownFieldComponent;
